class ProductCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiperEl = this.querySelector("swiper-container");
    this.sectionId = this.dataset.sectionId;
    this.swiperParams = {
      slidesPerGroup: 1,
      slidesOffsetAfter: this.getSlidesOffset(),
      slidesOffsetBefore: this.getSlidesOffset(),
      slidesPerView: "auto",
      spaceBetween: 8,
      navigation: {
        prevEl: `#shopify-section-${this.sectionId} button[data-direction="prev"]`,
        nextEl: `#shopify-section-${this.sectionId} button[data-direction="next"]`,
      },
      breakpoints: {
        750: {
          spaceBetween: 16,
        },
      },
      on: {
        init: () => this.setAttribute("data-swiper-initialized", "true"),
      },
    };

    Object.assign(this.swiperEl, this.swiperParams);
    this.swiperEl.initialize();
    this.swiperEl.swiper.on("resize", this.onSwiperResize.bind(this));
  }

  onSwiperResize() {
    this.swiperEl.slidesOffsetAfter = this.getSlidesOffset();
    this.swiperEl.slidesOffsetBefore = this.getSlidesOffset();
  }

  getSlidesOffset() {
    const pageWidthStyle = getComputedStyle(document.querySelector(".page-width")).getPropertyValue("max-width");
    const pageWidth = parseInt(pageWidthStyle, 10);
    const pageMarginStyle = getComputedStyle(document.querySelector(".page-width")).getPropertyValue("padding-left");
    const slidesOffset =
      window.innerWidth > pageWidth
        ? (window.innerWidth - pageWidth) / 2 + parseInt(pageMarginStyle, 10)
        : parseInt(pageMarginStyle, 10);
    return slidesOffset;
  }
}

customElements.define("product-carousel", ProductCarousel);
